module.exports = "/_next/static/images/f137557104b5cba221fd9c10ea7f6fc1-word-cup-md-3x.png";